import { fetchAccountData } from '../../api/api_account.js'; // 계좌번호 정보를 POST하는 함수
import { insertIntoDB } from '../../api/api_dbInsert.js'; // 계좌번호 정보를 POST하는 함수
import { saveInvitation } from '../../api/api_saveInvitation.js'; // 계좌번호 정보를 POST하는 함수
import { handleSaveResponse } from '../../api/api_saveInvitation_modules/handleSaveResponse.js'; // 템플릿 저장시, 반환되는 결과값

import { showLoadingSpinner, hideLoadingSpinner } from '../../components/spinner.js';
import { dataCollector } from '../../views/template_modules/template_saveTemplates_modules/dataCollertor.js'; // 
import { template_design_data } from './template_saveTemplates_modules/template_design/template_design_data.js';
import { template_transportation_data } from './template_saveTemplates_modules/template_weddingInfo/template_transportation_data.js';

export function saveTemplates(dynamicValue) {
    let saveButtons = document.querySelectorAll('.ProgressSave');
    let saveAlert = document.querySelector('.ModalSaveComplete');
    let dimmed = document.getElementById('SaveCompleteDimmed');
    let closeBtn = document.querySelector('#SaveCompleteDimmed .close-button');
    const scrollPreventEvent = document.body;

    // 진행 중인 저장 작업을 추적하는 플래그
    let isSaving = false;
    // 이벤트 리스너가 이미 추가되었는지 확인하는 플래그
    let eventListenersAdded = false;

    // 저장하기 클릭시 동작하는 코드 정리
    let toggleElements = () => {
        hideLoadingSpinner();
        dimmed.classList.toggle('is-active');
        saveAlert.classList.toggle('is-active');
        // if (closeBtn) closeBtn.style.display = 'none';
        scrollPreventEvent.style.overflowY = 'scroll';
        isSaving = false; // 저장 작업 완료 시 플래그 리셋
    };

    // 모달 닫기 함수
    const closeModal = () => {
        console.log('closeModal 함수 호출됨');
        
        if (dimmed) {
            console.log('dimmed 토글 실행');
            toggleElements();
        } else {
            console.log('dimmed 요소를 찾을 수 없습니다');
        }
    };

    if (saveButtons && !eventListenersAdded) {
        saveButtons.forEach(saveButton => {
            // 기존 이벤트 리스너 제거 (중복 방지)
            saveButton.removeEventListener('click', handleSaveClick);
            // 새 이벤트 리스너 추가
            saveButton.addEventListener('click', handleSaveClick);
        });
        eventListenersAdded = true;
    }

    // 저장 버튼 클릭 핸들러를 별도 함수로 분리
    async function handleSaveClick() {
        // 이미 저장 중인 경우 중복 실행 방지
        if (isSaving) {
            console.log('이미 저장 중입니다.');
            return;
        }

        isSaving = true;

        try {
            const ModalGroups = document.querySelector('.ModalGroups');
            const ModalGroupsData = ModalGroups ? ModalGroups.outerHTML : '';

            // 좌측 사이드 템플릿과 이미지URL을 DB에 저장하는 함수
            const sideContentsEl = document.querySelector('.side_contents');
            const sideContents = sideContentsEl ? sideContentsEl.outerHTML : '';

            showLoadingSpinner();

            // 저장할 데이터를 가져오는 모듈 함수를 불러옵니다.
            const DBData = await dataCollector(dynamicValue);
            const template_design_dataSet = template_design_data(dynamicValue);

            // 서버로 전송할 데이터를 객체로 정의합니다.
            const requestData = {
                ModalGroups: ModalGroupsData,
                sideContents: sideContents, // 변경된 HTML 코드를 전송
                DBData: DBData,
                template_design_data: template_design_dataSet,
            };

            try {
                // 계좌정보를 POST하는 API 모듈
                let accountDataInfo = DBData.accountInfoData;
                await fetchAccountData(dynamicValue, accountDataInfo);
                
                // link 태그 요소 제거 (9번, 10번 항목)
                if (DBData.order_tab && Array.isArray(DBData.order_tab)) {
                    DBData.order_tab = DBData.order_tab.filter(item => !item.href);
                    console.log('필터링된 order_tab:', DBData.order_tab);
                }
                
                // DB Post API 모듈
                const dbResponse = await insertIntoDB(DBData);
                if (!dbResponse.ok) {
                    throw new Error('데이터 삽입에 실패했습니다.');
                }
                
                console.log('데이터가 성공적으로 삽입되었습니다.');
                
                // 초대장 저장 모듈
                const saveResponse = await saveInvitation(dynamicValue, requestData);
                toggleElements();
                handleSaveResponse(saveResponse, dynamicValue, { 
                    dimmed, 
                    toggleElements, 
                    scrollPreventEvent, 
                    deleteBtn: closeBtn 
                });
            } catch (error) {
                console.error('API 호출 중 오류가 발생했습니다:', error);
                
                // JWT 자동 연장이 middleware에서 처리되므로 401/403 체크 불필요
                // 일반 오류 처리만 수행
                alert('저장 중 오류가 발생했습니다. 다시 시도해주세요.');
                
                hideLoadingSpinner();
                isSaving = false; // 오류 발생 시 플래그 리셋
            }
        } catch (error) {
            console.error('템플릿 저장 중 오류가 발생했습니다:', error);
            hideLoadingSpinner();
            isSaving = false; // 오류 발생 시 플래그 리셋
            alert('저장 중 오류가 발생했습니다. 다시 시도해주세요.');
        }
    }

    // closeBtn 이벤트 리스너 추가
    if (closeBtn) {
        console.log('closeBtn 요소 찾음:', closeBtn);
        closeBtn.removeEventListener('click', closeModal); // 중복 방지
        closeBtn.addEventListener('click', closeModal);
    } else {
        console.log('closeBtn 요소를 찾을 수 없습니다 - 선택자: #SaveCompleteDimmed .close-button');
    }
}
